import { apiClient, getAuthId, getToken } from '@devd-client/api';

export const getUser = (): Promise<any> =>
  apiClient(`/v2/account/user/${getAuthId()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
